import { DynamicModificationTarget } from './dynamic-modification-target';
export class DynamicModification {
    id: number;
    priorityOrder: number;
    anchorReference: string;
    modificationType: string;
    modificationTarget: DynamicModificationTarget;

}
